import cloneDeep from "lodash/cloneDeep";
import { SearchKeywordSliders } from "PFApp/search/parts/search_keyword_sliders";
import { buildFilterV2 } from "PFCore/helpers/filters/build_filter_v2";
import { Meta } from "PFTypes";
import { ApiFilterGroupV2 } from "PFTypes/filters_v2";
import { PageTarget } from "PFTypes/saved_filters";
import { useMemo } from "react";

import { KEYWORD_FILTER_KEY } from "../tabs_constants";

export const useMatchesMetaWithKeywordFilters = (matchesMeta: Meta): Meta =>
  useMemo(() => {
    if (!matchesMeta.filtersV2) {
      return matchesMeta;
    }

    const metaDraft = cloneDeep(matchesMeta);
    // we want to render Keyword Sliders inside filters panel- that's how it was done in the old version
    // Keywords should be removed from filters panel in new design of global search page
    // or keyword filters should be better integrated with normal filters
    metaDraft.filtersV2!.mainFilters[KEYWORD_FILTER_KEY] = buildFilterV2({
      name: KEYWORD_FILTER_KEY,
      group: ApiFilterGroupV2.Fields,
      collection: "" as PageTarget,
      ordinal: 1,
      InputComponent: SearchKeywordSliders,
      inputStyle: { fullWidth: true }
    });

    return metaDraft;
  }, [matchesMeta]);
